import { render, staticRenderFns } from "./onforestdutyRequests.vue?vue&type=template&id=37ce2c37&"
import script from "./onforestdutyRequests.vue?vue&type=script&lang=js&"
export * from "./onforestdutyRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports